<template>
    <div id="page" class="settings">
        <Navbar :title="'Instillinger'" :backBtn="'Home'"/>

        <div class="page-content header-clear-large">

            <div class="account-details profile-2">
                <UserDetails />
            </div>

            <div class="divider divider-margins"></div>

            <div class="content">

                <div class=" link-list-long-border">
                    
                    <!-- <div class="settings-links">
                        <span>Dark mode</span>
                        <ui-switch v-model="dark"></ui-switch>
                    </div> -->
                    <!-- <a href="#"><i class="fa fa-question-circle color-orange-dark"></i><span>Reset / Forgot</span><i
                            class="fa fa-angle-right"></i></a>
                    <a href="#"><i class="fa fa-wrench color-blue2-dark"></i><span>Maintenance</span><i
                            class="fa fa-angle-right"></i></a>
                    <a href="#"><i class="fa fa-users color-yellow2-dark"></i><span>Team Page</span><i
                            class="fa fa-angle-right"></i></a>
                    <a href="#"><i class="fa fa-server color-aqua-dark"></i><span>System Status</span><i
                            class="fa fa-angle-right"></i></a> -->

                    <a class="ui-collapsible__header-content settings-links">
                        <i class="fas fa-question color-blue2-dark"></i>
                        <span>Versjon 1.0 beta</span>
                    </a>

                    <ui-collapsible :open="accordions[1]" @open="onAccordionOpen(1)" @close="onAccordionClose(1)">
                        <div slot="header">
                           <i class="fas fa-lock color-orange-dark"></i>
                           <span>Edit Password</span>
                         </div>
                         <ChangePassword />
                    </ui-collapsible>

                    <ui-collapsible :open="accordions[2]" @open="onAccordionOpen(2)" @close="onAccordionClose(2)">
                        <div slot="header">
                           <i class="fas fa-user color-orange-dark"></i>
                           <span>Edit User Info</span>
                         </div>
                         <EditUser />
                    </ui-collapsible>

                    <ui-collapsible v-if="isAdmin" :open="accordions[0]" @open="onAccordionOpen(0)" @close="onAccordionClose(0)">
                        <div slot="header">
                           <i class="fas fa-users color-orange-dark"></i>
                           <span>New User</span>
                         </div>
                         <CreateUser />
                    </ui-collapsible>
                    
                    <router-link v-if="isAdmin" :to="{name: 'UsersList'}" class="ui-collapsible__header-content settings-links">
                        <i class="fas fa-users color-orange-dark"></i>
                        <span>Endre Brukere</span>
                    </router-link>

                    <a @click="logout" class="ui-collapsible__header-content settings-links">
                        <i class="fas fa-sign-out-alt color-orange-dark"></i>
                        <span>Logg Ut</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="menu-hider"></div>
  </div>
</template>

<script>
// import LoginForm from '@/components/auth/LoginForm'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import UserDetails from  '@/components/profile/UserDetails'
import Navbar from '@/components/layouts/Navbar'
import CreateUser from '@/components/auth/CreateUser'
import EditUser from '@/components/auth/EditUser'
import ChangePassword from '@/components/auth/ChangePassword'

export default {
    name: 'Accounting',
    components: {
        UserDetails,
        Navbar,
        CreateUser,
        EditUser,
        ChangePassword
    },
    data(){
        return{
             accordions: {
                0: false,
                1: false,
                2: false
            },
            dark: false,
            isAdmin: false
        }
    },
    methods: {
        logout(){
            firebase.auth().signOut().then(() => {
                this.$router.push({ name: 'Login' })
                localStorage.removeItem('user');
            })
        },
        darkMode(){
            document.querySelector("body").toggleClass('theme-dark theme-light')
        },
        onAccordionOpen(id) {
            Object.keys(this.accordions).forEach(key => {
                this.accordions[key] = key == id; // eslint-disable-line eqeqeq
            });
        },
        onAccordionClose(key) {
            this.accordions[key] = false;
        },
    },
    created(){
        firebase.auth().currentUser.getIdTokenResult().then(idTokenResult => {
            this.isAdmin = idTokenResult.claims.admin
        })
    }
}
</script>

<style>
.ui-collapsible__header{
    background-color: #fff!important;
    padding-left: 0!important;
    padding-right: 0!important;
}
.settings .ui-collapsible__header-content span{
    margin-left: 10px
}
.settings-links{
    color: black;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    font-size: 0.9375rem;
    margin-bottom: 0.5rem;
}
.ui-collapsible__body{
    border: none!important;
    padding: 0!important;
}
</style>